
import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ShippingInfomation from "routes/front/main/shopping/orderSummary/ShippingInfomation";
import style from "./OrderSummaryPage.module.css";
import { useTranslation } from "react-i18next";
import CIcon from "@coreui/icons-react";
import { cilCreditCard } from "@coreui/icons";
import Center from "layouts/wrapper/Center";
import InputText from "components/inputs/signUp/InputText";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import visacard from "resources/img/paymentMethod/visa_logo.png";
import OrderProducttRow from "routes/front/main/shopping/OrderProducttRow";
import CheckCircleGroup from "components/inputs/checkBox/CheckCircleGroup";
import Terms from "modals/sign/signUp/Terms";
import CustomButton from "components/buttons/CustomButton";
import { toast } from "react-toastify";
import { AuthContext } from "providers/AuthProvider";
import { addCommas, validateInputs } from "shared/utils/Utils";
import { requester } from "App";
import Inline from "layouts/container/Inline";

function OrderSummaryPage() {
    const location = useLocation();
    const { productId, id } = useParams();
    const { userName } = useContext(AuthContext);
    const cartData = useSelector((state) => state.cart.products);
    const [products, setProducts] = useState([]);
    const shippingInfoRef = useRef();
    const messageRef = useRef();
    const [selectedShippingInfo, setselectedShippingInfo] = useState();
    const [shippingType, setShippingType] = useState("NEW");
    const [quantity, setQuantity] = useState();
    const [agreeSelectedList, setAgreeSelectedList] = useState([]);
    const [agree, setAgree] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const paymentMethods = [
        // { id: 1, title: "가상계좌", icon: null },
        { id: 1, title: "CARD", icon: visacard },
        // { id: 3, title: "Alipay", icon: alipay },
        // { id: 4, title: "Wechatpay", icon: wechatpay },
        // { id: 5, title: "Unionpay", icon: unionpay },
        // { id: 6, title: "Paypal", icon: paypal }
    ];
    const rowIndex = [
        {
            id: 1,
            accent: true,
            text: t("consentToCollectionOfPersonalInformation"),
        },
        {
            id: 2,
            accent: true,
            privacy: true,
            text: t("consentToPaymentAgency"),
        }
    ];

    const [paymentMethod, setPaymentMethod] = useState(paymentMethods[0]);



    useEffect(() => {
        let total = 0;
        if (productId === "cart") {
            setProducts(cartData);
            total = cartData.reduce((acc, item) => acc + item.quantity * item.price, 0);
            setTotalAmount(total);
        } else if (location.state?.product) {
            // 객체를 배열 안에 담아서 setProducts 호출
            setProducts([location.state?.product]);
            setQuantity(location.state.quantity);
            total = location.state.quantity * location.state?.product.price;
            setTotalAmount(total);
        }
    }, [cartData, productId, location.state]);
    const shippingCallback = (value, type) => {

        setselectedShippingInfo(value);
        setShippingType(type);
        if (shippingType === "NEW") {
            // setNewShippingInfo(shippingInfoRef.current.getData([]));
        }
    };
    const onPaymentMethodClick = () => {
        // NiceModal.show("paymentMethodSelectModal", { initialId: paymentMethod.id, onSelect: onPaymentMethodModalSelect });
    }

    const onCheckGroupCallback = (checkedIndex) => {
        let selectedProducts = [];
        checkedIndex && checkedIndex.map((index) => {
            selectedProducts.push(rowIndex[index]);
        });
        setAgreeSelectedList(selectedProducts);
    }
    const onOrderSummaryClick = () => {
        if (agree) {


            if (quantity) {
                //즉시구매

                const updatedProduct = { ...products[0], quantity: quantity };
                const updatedProducts = [updatedProduct]
                const newTotal = updatedProducts.reduce((acc, item) => acc + item.quantity * item.price, 0);

                let data = {
                    orderProducts: updatedProducts,
                    amount: newTotal,
                    userName: userName,
                    storeCode: id,
                    returnUrl: 'http://118.42.47.43:3000/homepage',
                    address: shippingInfoRef.current.getData().addressKr,
                    addressDetail: shippingInfoRef.current.getData().addressDetail,
                    zipcode: shippingInfoRef.current.getData().postalCodeKr,
                    message: messageRef.current.getValue()
                };
                
                validateInputs(shippingInfoRef.current).then((result) => {
                    
                    if (result.isValid) {

                        
                        if (shippingInfoRef.current.getData().addressDetail && shippingInfoRef.current.getData().addressDetail.length > 1) {
                            if (shippingInfoRef.current.getData().mobileNo && shippingInfoRef.current.getData().mobileNo.length > 10) {
                                //주소가 올바르게 입력되었다면 

                                requester.testPaymentRequest(data, (result) => {
                                    if (result.code === 0) {
                                        
                                        let ready = result.data;
                                        requester.testPayment(ready, (result) => {
                                            if (result.code === 0) {
                                                
                                                navigate(`/ws/${id}/homepage/payment`, { state: { data: result.data } }, { replace: true })
                                            }
                                        })
                                    } else {
                                        toast.error("문제가 발생했습니다 관리자에게 문의하세요", {
                                            autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                                        });
                                    }
                                });
                            } else {
                                toast.error(t("pleaseCheckNumber"), {
                                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                                });
                            }
                        } else {
                            if (shippingInfoRef.current.getData().mobileNo && shippingInfoRef.current.getData().mobileNo.length > 1) {
                                toast.error(t("addressComfirm"), {
                                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                                });
                            } else {
                                toast.error(t("addressComfirm"), {
                                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                                });
                            }


                        }
                    } else {
                        
                       
                    }
                });

            } else {
                //카트구매

                const newTotal = cartData.reduce((acc, item) => acc + item.quantity * item.price, 0);
                let data = {
                    orderProducts: cartData,
                    amount: newTotal,
                    userName: userName,
                    storeCode: id,
                    returnUrl: 'http://localhost:3000/homepage/',
                    address: shippingInfoRef.current.getData().addressKr,
                    addressDetail: shippingInfoRef.current.getData().addressDetail,
                    zipcode: shippingInfoRef.current.getData().postalCodeKr,
                    message: messageRef.current.getValue()
                };
                
                validateInputs(shippingInfoRef.current).then((result) => {
                    if (result.isValid) {


                        if (shippingInfoRef.current.getData().addressDetail.length > 1) {
                            if (shippingInfoRef.current.getData().mobileNo.length > 10) {
                                //주소가 올바르게 입력되었다면 

                                requester.testPaymentRequest(data, (result) => {
                                    
                                    if (result.code === 0) {
                                        
                                        let ready = result.data;
                                        requester.testPayment(ready, (result) => {
                                            if (result.code === 0) {
                                                
                                                navigate(`/ws/${id}/homepage/payment`, { state: { data: result.data } }, { replace: true })
                                            }
                                        })
                                    } else {
                                        toast.error("문제가 발생했습니다 관리자에게 문의하세요", {
                                            autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                                        });
                                    }
                                });
                            } else {
                                toast.error(t("pleaseCheckNumber"), {
                                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                                });
                            }
                        } else {
                            if (shippingInfoRef.current.getData().mobileNo.length > 1) {
                                toast.error(t("addressComfirm"), {
                                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                                });
                            } else {
                                toast.error(t("addressComfirm"), {
                                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                                });
                            }
                        }
                    } else {
                        
                    }
                });


            }


        } else {
            toast.error(`약관에 동의해주세요.`, {
                autoClose: 1000,
                position: toast.POSITION.BOTTOM_CENTER
            });
        }
    }

    useEffect(() => {
        agreeSelectedList.map((data, index) => {
            if (data.accent && agreeSelectedList.length >= 2) {
                setAgree(true);
            } else {
                setAgree(false);
            }
            if (agreeSelectedList.length >= 3) {
                setAgree(true);
            }
        })
    }, [agreeSelectedList]);


    return (
        <Container maxWidth={1200}>
            <VerticalFlex flexStart>
                <FlexChild>
                    <ShippingInfomation ref={shippingInfoRef} callback={shippingCallback} />
                </FlexChild>
                <FlexChild>
                    <Center width={"100%"} textAlign={"left"}>
                        <P size={16} weight={"bold"}>
                            {t("배송 요청사항")}
                        </P>
                    </Center>
                </FlexChild>
                <FlexChild>
                    <InputText ref={messageRef} placeHolder={"배송 메세지를 입력하세요."} />
                </FlexChild>
                <FlexChild padding={"20px 0 5px 0"}>
                    <Center width={"100%"} textAlign={"left"}>
                        <P weight={"bold"} size={"18pt"}>{t("selectPaymentMethod")}</P>
                    </Center>
                </FlexChild>
                <FlexChild>
                    <div className={style.paymentMethodArea} onClick={onPaymentMethodClick}>
                        <HorizontalFlex backgroundColor={"white"} padding={5} gap={10}>
                            <FlexChild width={30} backgroundColor={"white"} >
                                <Center>
                                    <CIcon icon={cilCreditCard} size={"lg"} />
                                </Center>
                            </FlexChild>
                            <FlexChild>
                                <HorizontalFlex gap={10}>
                                    <FlexChild>
                                        <P>{paymentMethod.title}</P>
                                    </FlexChild>
                                    {/* <FlexChild>
                                        <P>{user && user.accountNo}</P>
                                    </FlexChild> */}
                                </HorizontalFlex>
                            </FlexChild>

                        </HorizontalFlex>
                    </div>
                </FlexChild>
                <FlexChild>
                    <VerticalFlex gap={10}>
                        <FlexChild padding={"20px 0 5px 0"}>
                            <Center width={"100%"} textAlign={"left"}>
                                <P weight={"bold"} size={"14pt"}>{t("주문상품")}</P>
                            </Center>
                        </FlexChild>
                        <FlexChild>
                            <div className={style.orderListContainer}>
                                <VerticalFlex>

                                    {
                                        products &&
                                        products.map((data, index) =>
                                            <FlexChild key={index}>
                                                <OrderProducttRow readOnly key={index} index={index} data={data} quantity={quantity && quantity} />
                                            </FlexChild>)
                                    }
                                </VerticalFlex>
                            </div>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
                <FlexChild>
                    <VerticalFlex flexStart gap={20}>
                        <FlexChild>
                            <P weight={"bold"} size={"14pt"}>결제금액</P>
                        </FlexChild>
                        <FlexChild>
                            <Inline>
                                <P color={"black"} size={"22px"}>총액 : </P>
                                <P color={"black"} weight={"bold"} size={"22px"}>&#8361; {totalAmount && addCommas(totalAmount)}</P>
                            </Inline>
                        </FlexChild>

                    </VerticalFlex>


                </FlexChild>
                <FlexChild>
                    <CheckCircleGroup lineHeight={"28px"} callback={onCheckGroupCallback} flexStart padding={"7px 15px"} header={[{ width: "100%", text: t("agreeToTheTermsBelow"), alignItems: "center" },]}>
                        {
                            rowIndex &&
                            rowIndex.map((data, index) => (
                                <Terms orderSummary data={data} key={index} index={index} />
                            ))
                        }
                    </CheckCircleGroup>
                </FlexChild>
                <FlexChild>
                    <Center>
                        <CustomButton text={"결제하기"} onClick={onOrderSummaryClick} />
                    </Center>
                </FlexChild>

            </VerticalFlex>
        </Container>
    );
}

export default OrderSummaryPage;